var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v("會員數")]),_c('chart-line',{attrs:{"data":_vm.userData,"option":_vm.option}})],1)],1),_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v("換入點數")]),_c('chart-line',{attrs:{"data":_vm.pointData,"option":_vm.option}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }